import * as React from "react"

import { SESSION_ROUTES } from "@constants"
import LoginPage from "./Login"
import LogoutPage from "./Logout"


export const SessionRoutes = [{
	path: SESSION_ROUTES.LOGIN_URL,
	notRender: true,
	hideInHome: true,
	element: <LoginPage />
}, {
	path: SESSION_ROUTES.LOGOUT_URL,
	notRender: true,
	hideInHome: true,
	element: <LogoutPage />
}]